/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Client, RequestContext } from "../client";
import type { ResourceCollection, ApiKeyWithUserResource } from "../resources";
import type { ListArgs } from "./basicRepository";
export interface GetApiKeysResponse {
    ApiKeys: ResourceCollection<ApiKeyWithUserResource>;
}
interface ApiKeyListArgs extends ListArgs {
    partialPurpose?: string | undefined;
    neverExpire?: boolean | undefined;
    hasExpired?: boolean | undefined;
    willExpireInDays?: number | undefined;
    userId?: string | undefined;
}
export class ApiKeyRepository {
    private client: Client;
    constructor(client: Client, private readonly requestContext: RequestContext) {
        this.client = client;
    }
    listApiKeys(options?: ApiKeyListArgs): Promise<GetApiKeysResponse> {
        return this.client.get<GetApiKeysResponse>(this.requestContext, "~/bff/apikeys{?skip,take,partialPurpose,neverExpire,hasExpired,willExpireInDays,userId}", { ...options });
    }
}
